<template>
  <div>
    <div class="container">
      <div class="row">
        <div
          class="col-md-2 col-xs-4 repair-box-item"
          v-for="{ slug, name } in categoryInfo.subData"
          :key="slug"
        >
          <router-link tag="a" :to="getPath(`${categoryInfo.slug}/${slug}`)">
            <img
              :src="`/img/models/${categoryInfo.slug}/${slug}.jpg`"
              :alt="name"
              :title="name"
              :data-fallback="`https://placehold.co/400?text=${name}`"
              onerror="this.onerror=null;this.src=this.getAttribute('data-fallback')"
            />
            <span class="repair-box-item__title">{{ name }}</span>
          </router-link>
        </div>
      </div>
      <div class="row mt-20">
        <div class="container">
          <div class="col-md-12">
            <div v-html="categoryInfo[`description_${$i18n.locale}`]"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RepairPageMixin from '@/components/repair/RepairPageMixin'

export default {
  name: 'RepairServiceCategory',
  mixins: [RepairPageMixin],
}
</script>

<style>
</style>
